import React from 'react';

import { Select, TextField } from 'components/Inputs';
import { Container, Item, Row } from 'components/Layout';

export const IsochronyCustomization = ({
  params,
  setParams,
  err,
  color = null,
  bgColor = null
}) => {
  const timeUnit = [
    {
      label: 'minute',
      value: 'min'
    },
    {
      label: 'heure',
      value: 'hr'
    }
  ];
  const transport = [
    {
      label: 'à pied',
      value: 'pedestrian'
    },
    {
      label: 'en voiture',
      value: 'auto'
    },
    {
      label: 'à vélo',
      value: 'bicycle'
    }
  ];

  return (
    <Container>
      <Row justify="flex-start" alignItems="flex-end" spacing={1}>
        <Item xs={3}>
          <TextField
            title="Temps de déplacement"
            small
            error={err}
            bgColor={bgColor}
            errorText="L'isochronie est limitée à des déplacements de deux heures maximum"
            value={params.time}
            color={color}
            type="numberInt"
            onChange={e => setParams({ ...params, time: e })}
          />
        </Item>
        <Item xs={3}>
          <Select
            small
            bgColor={bgColor}
            color={color}
            value={params.unit}
            options={timeUnit}
            onChange={change =>
              setParams({
                ...params,
                unit: change
              })
            }
          />
        </Item>
        <Item xs={6}>
          <Select
            small
            title="Moyen de transport"
            bgColor={bgColor}
            color={color}
            value={params.transportation}
            options={transport}
            onChange={change =>
              setParams({
                ...params,
                transportation: change
              })
            }
          />
        </Item>
      </Row>
    </Container>
  );
};

export default IsochronyCustomization;
